import React from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { push } from "react-router-redux"
import { Route, Link, Switch } from "react-router-dom"
import {
  Slider,
  Select,
  Button as AButton,
  Col,
  Row,
  Icon as AIcon,
  Radio,
  Tooltip,
  Dropdown,
  Menu,
  Input,
  Modal
} from "antd"

import {
  MoreIcon,
  CheckedIcon,
  InvoiceIcon,
  VisaLogo,
  MastercardLogo,
  AmericanExpressLogo,
  DiscoverLogo,
  DinersClubLogo,
  JCBLogo
} from "../core/icons"
import Line from "../core/Line"
// import CreateSubscriptionSuccessModal from "./CreateSubscriptionSuccessModal"

import Card, { TitleCard, CardHeader } from "../core/Card"
import { getPlans, getInvoices, handleCancelReactivateClick } from "./actions"
import onMount from "../core/onMount"
import twix from "twix"
import moment from "moment"
import numeral from "numeral"

import Features from "./Features"
import PlanLines from "./PlanLines"
import FAQ from "./FAQ"
import ConnectedPlan from "./ConnectedPlan"
import PremiumFeatures from "./PremiumFeatures"
import NewStripeForm from "./NewStripeForm"
import {
  CreateSubModal,
  UpdateSubModal,
  ManageStripeForm,
  CancelOrReactivateSub
} from "./"

const Status = connect(
  state => {
    const { customer } = state.models.user.subscription || {
      customer: { source: {} }
    }
    const upcomingInvoice = state.models.invoices.find(
      invoice => invoice.billing_reason == "upcoming"
    )

    return {
      customer,
      isFetching: state.models.user.isFetching || state.subs.isFetchingInvoices,
      isSetToCancel: customer && customer.cancel_at_period_end,
      upcomingInvoice,
      seats:
        state.models.user.group_as_enterprise_owner &&
        customer.subscription.quantity
    }
  },
  { handleCancelReactivateClick }
)(
  ({
    handleCancelReactivateClick,
    customer,
    isSetToCancel,
    upcomingInvoice = { amount_due: 0 },
    seats,
    isFetching
  }) => (
    <Card showLoadingIcon={isFetching}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 20
        }}
      >
        <h1 style={{ margin: 0 }}>Subscription Status</h1>
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="0">
                {isSetToCancel ? (
                  <a onClick={handleCancelReactivateClick}>
                    <AIcon type="sync" /> Reactivate
                  </a>
                ) : (
                  <a
                    style={{ color: "#D54747" }}
                    onClick={handleCancelReactivateClick}
                  >
                    <AIcon type="close" /> Set to Cancel
                  </a>
                )}
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <a className="ant-dropdown-link" href="#">
            <AIcon type="ellipsis" style={{ fontSize: 30 }} />
          </a>
        </Dropdown>
      </div>

      {/* <p>Account Balance: {customer.account_balance}</p> */}

      <Row type="flex" align="middle" style={{ padding: 10 }} gutter={20}>
        <Col sm={3} xs={0} />

        <Col
          xs={24}
          sm={4}
          style={isSetToCancel ? { color: "#D54747" } : { opacity: 0.5 }}
        >
          {isSetToCancel ? "Will Cancel On:" : "Next Bill Date:"}
        </Col>
        <Col sm={12}>
          {customer.current_period_end}
          {isSetToCancel && (
            <AButton
              type="primary"
              style={{ marginLeft: 20 }}
              onClick={handleCancelReactivateClick}
            >
              REACTIVATE
            </AButton>
          )}
        </Col>
      </Row>
      <Row type="flex" align="middle" style={{ padding: 10 }} gutter={20}>
        <Col xs={0} sm={3} />

        <Col xs={24} sm={4} style={{ opacity: 0.5 }}>
          Next Amount:
        </Col>
        <Col sm={12}>
          {numeral(upcomingInvoice.amount_due / 100).format("($0,0.00)")}
          {seats && (
            <i style={{ opacity: 0.5 }}>
              {" "}
              ({seats} seats at{" "}
              {numeral(upcomingInvoice.amount_due / 100 / seats).format(
                "($0,0.00)"
              )}{" "}
              per seat)
            </i>
          )}
        </Col>
      </Row>
    </Card>
  )
)

export default Status



// WEBPACK FOOTER //
// ./src/subscriptions/Status.js